export function createLinkFromItem(itemA, type) {
    return {
        id: `${itemA.uuid}-${type}`,
        item: itemA,
        type,
    };
}
